module.exports = __webpack_public_path__ + "img/contact.b1a411e4.webp";